import { render, staticRenderFns } from "./VerandaStructure.vue?vue&type=template&id=56aa262c"
import script from "./VerandaStructure.vue?vue&type=script&lang=ts"
export * from "./VerandaStructure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports